<!-- Una sola línea: el detalle vive en el diálogo, donde hay ancho para
     leerlo. Acá entraba recortado con puntos suspensivos en casi toda
     pantalla, y una promesa cortada a la mitad no convence a nadie. -->
<button *ngIf="visible" type="button" (click)="instalar()" class="install-app-button"
  [attr.aria-label]="titulo">
  <span class="install-app-icon">
    <mat-icon>install_mobile</mat-icon>
  </span>
  <span class="install-app-title">{{ titulo }}</span>
</button>
